<template>
  <v-navigation-drawer
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    app
    clipped
  >
    <v-list dense>

      <template
        v-if="$auth.isAuthenticated"
      >
        <v-list-item
          :to="{ name: 'profile' }"
          class="px-2"
        >
          <v-list-item-avatar>
            <v-img
              :src="$auth.user.picture"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="$auth.user.nickname" />
            <v-list-item-subtitle v-text="$auth.user.name" />
          </v-list-item-content>
          <v-btn
            icon
            @click.prevent.stop="$emit('input', false)"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>
        
        <v-divider />
      </template>

      <v-list-item
        :to="{ name: 'home' }"
      >
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'table' }"
      >
        <v-list-item-action>
          <v-icon>mdi-table</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Table</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'item-edit', params: { itemId: 'add' } }"
      >
        <v-list-item-action>
          <v-icon>mdi-text-box-plus</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Add Item</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item link>
        <v-list-item-action>
          <v-icon>mdi-email</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Contact</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="{ name: 'about' }"
      >
        <v-list-item-action>
          <v-icon>mdi-information</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>About</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <!-- Check that the SDK client is not currently loading before accessing is methods -->
      <template v-if="!$auth.loading">
        <!-- show login when not authenticated -->
        <v-list-item
          v-if="!$auth.isAuthenticated"
          v-on:click="login()"
        >
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- show logout when authenticated -->
        <v-list-item
          v-if="$auth.isAuthenticated"
          v-on:click="logout()"
        >
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import authMixin from '@/mixins/authMixin'

export default {
  props: {
    value: Boolean,
  },
  mixins: [authMixin],
  methods: {
    
  },
}
</script>